import styles from './Frontend.module.scss'
import LpIntroduction from './LpIntroduction'
import Features from './Features'
import Process from './Process'
import Performance from './Performance'
import Cards from './Cards'
import SPCards from './SPCards'
import ProjectFlow from './ProjectFlow'
import FAQ from './FAQ'
import Contact from './Contact'

const Frontend: React.FC = () => {
  return (
    <article className={styles.LPPage} id="frontendLP">
      <LpIntroduction />
      <div className={styles.contents}>
        <Features />
        {/* <Process /> */}
        <Performance />
        <Cards />
        <SPCards />
        <ProjectFlow />
        <FAQ />
        <Contact />
      </div>
    </article>
  )
}

export default Frontend
